import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { Desktop, Mobile } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { BACKOFFICE_NAME } from '../../helpers/helperFunctions';
import {
  EVENT_PROMOTION,
  SETTINGS_SECURITY,
  SETTINGS_VIRTUAL_OFFICE,
  SUPER_SALES,
  TRAVEL_PACKAGES
} from '../../routes/routes';
import { color } from '../../styles/GlobalStyles';
import { getDashboardInfo } from './Dashboard.actions';
import { PackageRankUpgradeNotification } from './Dashboard.types';
import { DashboardNotification } from './DashboardNotification';
import { EarningsComponent } from './EarningsComponent';
import { MoneyBack } from './MoneyBack';
import { NumberOfMembers } from './NumberOfMembers';

import { RankNotification } from './RankNotification';
import { StatisticalComponent } from './StatisticalComponent';
import { SubscriptionWarning } from './SubscriptionWarning';

import { WelcomeSidebar } from './WelcomeSidebar';

import goldenCardBanner from '../../assets/images/backoffice/goldenCard/goldenCardBanner.png';
import goldenCardBannerMobile from '../../assets/images/backoffice/goldenCard/goldenCardBannerMobile.png';

import goldenCardBannerDisabled from '../../assets/images/backoffice/goldenCard/goldenCardBannerDisabled.png';
import goldenCardBannerMobileDisabled from '../../assets/images/backoffice/goldenCard/goldenCardBannerMobileDisabled.png';

import snappBanner from '../../assets/images/backoffice/snapp/snappBanner.png';
// import snapperBannerMobile from '../../assets/images/backoffice/snapper/snapperBannerMobile.png';

import superSalesBanner from '../../assets/images/backoffice/superSales/superSalesBanner.png';
import superSalesBannerMobile from '../../assets/images/backoffice/superSales/superSalesBannerMobile.png';

import travelutionPromotion from '../../assets/images/backoffice/travelutionPromotion.png';
import travelutionPromotionMobile from '../../assets/images/backoffice/travelutionPromotionMobile.png';

import carsBanner from '../../assets/images/backoffice/carsBanner.png';
import carsBannerBannerMobile from '../../assets/images/backoffice/carsBannerMobile.png';

import saveAndTravelBanner from '../../assets/images/backoffice/saveAndTravelBanner.png';
import saveAndTravelBannerMobile from '../../assets/images/backoffice/saveAndTravelBannerMobile.png';

import debitCardsBanner from '../../assets/images/backoffice/debitCardsBanner.png';
import debitCardsBannerMobile from '../../assets/images/backoffice/debitCardsBannerMobile.png';

import eventBanner from '../../assets/images/backoffice/event.png';
import eventBanerMobile from '../../assets/images/backoffice/eventMobile.png';

import { IconTitleStyled } from './DashboardStyled';
import { PurchasePackageAndCombo } from '../Marketplace/PurchasePackageAndCombo/PurchasePackageAndCombo';
import {
  getEventTickets,
  getGoldenCard,
  getGoldenCardStatus,
  setPurchaseCardStep
} from '../Marketplace/Marketplace.actions';
import { getMyHubsGoldenCard } from '../Portfolio/Portfolio.actions';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import WaitingForPaymentPackage from '../Orders/WaitingForPaymentPackage';
import { GoldenCard, PurchaseSteps } from '../Marketplace/Maeketplace.types';
import { AnimatedTab } from '../../components/animation/AnimatedTab';
import PaymentPage from '../Marketplace/PurchasePackageAndCombo/PaymentPage';
import { Success } from '../Marketplace/PurchasePackageAndCombo/Success';
import { Failed } from '../Marketplace/PurchasePackageAndCombo/Failed';

const Dashboard = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation('dashboard');

  const { user, isSideModalChecked, isCanadaRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );

  const { dashboardInfo, joinedAfterCount, loading } = useAppSelector(
    (state) => state.dashboard
  );

  const { eventTicket, goldenCard, goldenCardStatus, step } = useAppSelector(
    (state) => state.marketplace
  );

  const [welcome, setWelcome] = useState(!isSideModalChecked);

  const [goldenCardModal, setGoldenCardModal] = useState(false);
  const [eventTicketsModal, setEventTicketsModal] = useState(false);
  const [selectedGoldenCard, setSelectedGodlenCard] = useState<
    GoldenCard | undefined
  >();

  const [selectedEventTicket, setSelectedEventTicket] = useState<
    GoldenCard | undefined
  >();

  const [paymentInstructionsModal, setPaymentInstructionsModal] =
    useState(false);

  const [
    eventTicketsPaymentInstructionsModal,
    setEventTicketsPaymentInstructionsModal
  ] = useState(false);

  const history = useHistory();

  useEffect(() => {
    dispatch(getDashboardInfo());
    dispatch(getGoldenCard());
    dispatch(getEventTickets());
    dispatch(getGoldenCardStatus());
    dispatch(getMyHubsGoldenCard());
  }, [dispatch]);

  const StartYourJourneyNotification = () => {
    if (!dashboardInfo?.user?.currentVirtualOfficeLicence) {
      return (
        <DashboardNotification
          pill={'take the first step today'}
          title={'Start your Journey HERE!'}
          text={`To achieve the fastest growth, start with the MaVie ${BACKOFFICE_NAME} Subscription.`}
          buttonText={`Start with a ${BACKOFFICE_NAME}`}
          buttonOnClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}
        />
      );
    } else return null;
  };

  const SecurityNotification = () => {
    if (!dashboardInfo?.user?.settings?.signInEmailCodeVerificationEnabled) {
      return (
        <DashboardNotification
          titleColor={color.colors.error500}
          pill={t('notifications.security.pill')}
          title={t('notifications.security.title')}
          text={t('notifications.security.text')}
          buttonText={t('notifications.security.button')}
          buttonOnClick={() => history.push(SETTINGS_SECURITY)}
        />
      );
    } else return null;
  };

  if (loading && !dashboardInfo) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'dashboardInfo'}>
      <div style={{ margin: '70px 0' }}>
        <IconTitleStyled>{t('earnings.notifications')}</IconTitleStyled>

        <StartYourJourneyNotification />
        {dashboardInfo?.packageRankUpgradeNotifications?.map(
          (notification: PackageRankUpgradeNotification, index: number) => {
            return <RankNotification notification={notification} key={index} />;
          }
        )}
        <SubscriptionWarning />

        <Desktop>
          <img
            src={debitCardsBanner}
            alt='airdropBanner'
            style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
          />
        </Desktop>
        <Mobile>
          <img
            src={debitCardsBannerMobile}
            alt='airdropBannerMobile'
            style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
          />
        </Mobile>

        <Link to={SUPER_SALES}>
          <Desktop>
            <img
              src={superSalesBanner}
              alt='airdropBanner'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Desktop>
          <Mobile>
            <img
              src={superSalesBannerMobile}
              alt='airdropBannerMobile'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Mobile>
        </Link>

        <Link to={TRAVEL_PACKAGES}>
          <Desktop>
            <img
              src={saveAndTravelBanner}
              alt='airdropBanner'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Desktop>
          <Mobile>
            <img
              src={saveAndTravelBannerMobile}
              alt='airdropBannerMobile'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Mobile>
        </Link>
        <Link to={EVENT_PROMOTION}>
          <Desktop>
            <img
              src={carsBanner}
              alt='airdropBanner'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Desktop>
          <Mobile>
            <img
              src={carsBannerBannerMobile}
              alt='airdropBannerMobile'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Mobile>
        </Link>
        {/* </Link> */}

        {/* <a
          href='https://resources.travelutionclub.com/presentations/Boosterpromotion.pdf'
          target='_blank'
          rel='noreferrer'>
          <Desktop>
            <img
              src={travelutionPromotion}
              alt='travelutionPromotion'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Desktop>
          <Mobile>
            <img
              src={travelutionPromotionMobile}
              alt='airdropBannerMobile'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Mobile>
        </a> */}
        {/* <Link to={TRAVEL_PACKAGES}>
          <Desktop>
            <img
              src={saveAndTravelBanner}
              alt='airdropBanner'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Desktop>
          <Mobile>
            <img
              src={saveAndTravelBannerMobile}
              alt='airdropBannerMobile'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Mobile>
        </Link> */}

        <Desktop>
          <img
            src={eventBanner}
            alt='airdropBanner'
            style={{
              width: '100%',
              borderRadius: 12,
              marginBottom: 40,
              cursor: 'pointer'
            }}
            onClick={() => {
              setSelectedEventTicket(eventTicket?.[0]);
              setEventTicketsModal(!eventTicketsModal);
              dispatch(
                setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_METHOD })
              );
              setEventTicketsPaymentInstructionsModal(
                !eventTicketsPaymentInstructionsModal
              );
            }}
          />
        </Desktop>
        <Mobile>
          <img
            src={eventBanerMobile}
            alt='airdropBannerMobile'
            style={{
              width: '100%',
              borderRadius: 12,
              marginBottom: 40,
              cursor: 'pointer'
            }}
            onClick={() => {
              setSelectedEventTicket(eventTicket?.[0]);
              setEventTicketsModal(!eventTicketsModal);
              dispatch(
                setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_METHOD })
              );
              setEventTicketsPaymentInstructionsModal(
                !eventTicketsPaymentInstructionsModal
              );
            }}
          />
        </Mobile>
        {/* </Link> */}

        <Desktop>
          <img
            src={
              goldenCardStatus === 'paid'
                ? goldenCardBannerDisabled
                : goldenCardBanner
            }
            alt='goldenCardBanner'
            style={{
              width: '100%',
              borderRadius: 12,
              marginBottom: 40,
              cursor: goldenCardStatus === 'paid' ? 'default' : 'pointer'
            }}
            onClick={() => {
              setSelectedGodlenCard(goldenCard?.[0]);
              if (goldenCardStatus === 'not-ordered') {
                setGoldenCardModal(!goldenCardModal);
                dispatch(
                  setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_METHOD })
                );
              } else if (goldenCardStatus === 'pending') {
                dispatch(
                  setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_PAGE })
                );

                setPaymentInstructionsModal(!paymentInstructionsModal);
              }
            }}
          />
        </Desktop>
        <Mobile>
          <img
            src={
              goldenCardStatus === 'paid'
                ? goldenCardBannerMobileDisabled
                : goldenCardBannerMobile
            }
            alt='goldenCardBannerMobile'
            style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            onClick={() => {
              setSelectedGodlenCard(goldenCard?.[0]);
              if (goldenCardStatus === 'not-ordered') {
                setGoldenCardModal(!goldenCardModal);
                dispatch(
                  setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_METHOD })
                );
              } else if (goldenCardStatus === 'pending') {
                dispatch(
                  setPurchaseCardStep({ step: PurchaseSteps.PAYMENT_PAGE })
                );

                setPaymentInstructionsModal(!paymentInstructionsModal);
              }
            }}
          />
        </Mobile>
        <a
          href='https://getsnapp.ai/travelution'
          target='_blank'
          rel='noreferrer'>
          <Desktop>
            <img
              src={snappBanner}
              alt='airdropBanner'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Desktop>
          <Mobile>
            <img
              src={snappBanner}
              alt='airdropBannerMobile'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Mobile>
        </a>
        {/* FAST START BONUS */}
        {!isCanadaRestrictedUser && <MoneyBack />}
        {/* MY OVERVIEW */}
        <EarningsComponent user={user} backOffice={dashboardInfo} />
        {/* STATISTICAL DATA */}
        <StatisticalComponent backOffice={dashboardInfo} />
        {/* <UnilevelDashboard /> */}
        {/* <ExclusiveGaming /> */}
        {/* <Exclusive /> */}
        {/* <KycPackageNotifications /> */}
        <SecurityNotification />
        <NumberOfMembers backOffice={dashboardInfo} count={joinedAfterCount} />
      </div>
      {!isCanadaRestrictedUser && (
        <WelcomeSidebar open={welcome} setOpen={setWelcome} />
      )}

      <PurchasePackageAndCombo
        selectedPackage={selectedEventTicket}
        modal={eventTicketsModal}
        setModal={setEventTicketsModal}
      />

      <PurchasePackageAndCombo
        selectedPackage={selectedGoldenCard}
        modal={goldenCardModal}
        setModal={setGoldenCardModal}
      />

      {/* EVENT TICKETS */}

      {/* <SidebarModal
        isOpen={eventTicketsPaymentInstructionsModal}
        setOpen={setEventTicketsPaymentInstructionsModal}
        title='Payment instructions'
        sidebarWidth={'511px'}>
        {step === PurchaseSteps.PAYMENT_PAGE && (
          <AnimatedTab key={PurchaseSteps.PAYMENT_PAGE}>
            <PaymentPage selectedPackage={eventTickets} />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.SUCCESS && (
          <AnimatedTab key={PurchaseSteps.SUCCESS}>
            <Success />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.FAILED && (
          <AnimatedTab key={PurchaseSteps.FAILED}>
            <Failed />
          </AnimatedTab>
        )}
      </SidebarModal> */}

      {/* GOLDEN CARD */}

      <SidebarModal
        isOpen={paymentInstructionsModal}
        setOpen={setPaymentInstructionsModal}
        title='Payment instructions'
        sidebarWidth={'511px'}>
        {step === PurchaseSteps.PAYMENT_PAGE && (
          <AnimatedTab key={PurchaseSteps.PAYMENT_PAGE}>
            <PaymentPage selectedPackage={goldenCard?.[0]} />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.SUCCESS && (
          <AnimatedTab key={PurchaseSteps.SUCCESS}>
            <Success />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.FAILED && (
          <AnimatedTab key={PurchaseSteps.FAILED}>
            <Failed />
          </AnimatedTab>
        )}
      </SidebarModal>
    </AnimatedDashboard>
  );
};

export default Dashboard;
